<div class="component-viewer">
    <mat-card>
        <mat-card-header style="display: inline;">
            <div class="d-flex justify-content-between align-items-center w-100">
                <div class="d-flex align-items-center gap-5">
                    <h2 class="mb-0">Simulators</h2>
                    <div class="d-flex align-items-center">
                        <span *ngIf="getUserFromSession().permissions.simulatorCount === 0">
                            {{simulators.length}} / Unlimited
                        </span>
                        <span *ngIf="getUserFromSession().permissions.simulatorCount > 0">
                            {{simulators.length}} / {{getUserFromSession().permissions.simulatorCount}}
                        </span>
                    </div>
                </div>
                <button mat-raised-button (click)="createSimulator()" [disabled]="simulators.length == getUserFromSession().permissions.simulatorCount">
                    Add <mat-icon>add</mat-icon>
                </button>
            </div>
        </mat-card-header>
        <mat-card-content>
            <gt-table *ngIf="true" [loading]="isLoading" [defaultPageSize]="10" [updateFilterEvent]="updateFilterEvent"
                [filter]="filter" [data]="simulators" (filterChanged)="getSimulators()" (filterReset)="resetFilter()">
            </gt-table>
            <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
            <table mat-table [dataSource]="simulators" matSort (matSortChange)="sortData($event)">
                <ng-container matColumnDef="bayNumber">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="bayNumber"> Bay Number </th>
                    <td mat-cell *matCellDef="let simulator"> {{simulator.bayNumber}} </td>
                </ng-container>
                <ng-container matColumnDef="bayName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="bayName"> Bay Name (Description) </th>
                    <td mat-cell *matCellDef="let simulator"> {{simulator.bayName}} </td>
                </ng-container>
                <ng-container matColumnDef="capacity">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="capacity"> Capcity </th>
                    <td mat-cell *matCellDef="let simulator"> {{simulator.capacity}} </td>
                </ng-container>
                <ng-container matColumnDef="isAvailable">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="isAvailable"> Available </th>
                    <td mat-cell *matCellDef="let simulator">
                        <section>
                            <mat-slide-toggle
                                [checked]="simulator.isAvailable"
                                (change)="updateIsAvailable(simulator, $event)">
                                <ng-container *ngIf="simulator.isAvailable">Yes</ng-container>
                                <ng-container *ngIf="!simulator.isAvailable">No</ng-container>
                            </mat-slide-toggle>
                        </section>
                    </td>
                </ng-container>
                <ng-container matColumnDef="lastEditedDate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="lastEditedDate"> Last Edited Date </th>
                    <td mat-cell *matCellDef="let simulator"> {{simulator.lastEditedDate | date: 'MMM d, y, h:mm a'}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let simulator">
                        <button mat-icon-button [matMenuTriggerFor]="actionsMenu">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #actionsMenu>
                            <button mat-menu-item (click)="edit(simulator)">
                                Edit <mat-icon>edit</mat-icon>
                            </button>&nbsp;
                            <button mat-menu-item (click)="delete(simulator)">
                                Delete <mat-icon>delete</mat-icon>
                            </button>
                        </mat-menu>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </mat-card-content>
    </mat-card>
</div>